import React, { useEffect, useState } from 'react';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import axios from 'axios';
import addbtn from '../../../safreeimg/addbtn.png';
import Loader from '../../../safreeimg/loader.gif';
import { useNavigate } from 'react-router-dom';
import leftarrow from '../../../safreeimg/left-arrow.png';
import { Link } from 'react-router-dom';

const OrgGroupViewDetail = () => {
    const [organisations, setOrganisations] = useState([]);
    const [groupName, setGroupName] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const hashId = window.location.hash.substring(1);  // Get group ID from the URL
    const rowsPerPage = 10;
    const navigate = useNavigate();

    useEffect(() => {
        const fetchOrganisations = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    setError('No authentication token found');
                    setLoading(false);
                    return;
                }

                if (!hashId) {
                    setError('No ID found in the URL hash');
                    setLoading(false);
                    return;
                }

                console.log('Extracted ID:', hashId);
                console.log('Token:', token);

                const response = await axios.get(
                    `https://api.safree.org/api-v2022/organization/auth/v1/group-users/${hashId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                console.log('API Response:', response);

                if (response.data && Array.isArray(response.data.data)) {
                    setOrganisations(response.data.data);
                    if (response.data.data[0]?.groupName) {
                        setGroupName(response.data.data[0].groupName);
                    }
                } else {
                    setError('Invalid data format from API');
                }
            } catch (err) {
                console.error('Error fetching organisations:', err);
                setError('An error occurred while fetching organisations: ' + err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchOrganisations();
    }, []);

    const totalPages = Math.ceil(organisations.length / rowsPerPage);
    const currentRows = organisations.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (direction) => {
        if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
        if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleBackClick = () => {
        navigate(-1);
    };

    const handleIdentityChange = (userId, newIdentity) => {
        // Show confirmation dialog before changing status
        const confirmChange = window.confirm(`Are you sure you want to change the status to ${newIdentity}?`);

        if (confirmChange) {
            console.log('Sending FormData with userId:', userId, 'and identity:', newIdentity);

            const token = localStorage.getItem('token');
            const formData = new FormData();
            formData.append('groupId', hashId);  // Group ID from URL
            formData.append('userId', userId);  // User ID
            formData.append('status', newIdentity);  // Updated identity

            // Log the FormData to see the content being sent
            for (let [key, value] of formData.entries()) {
                console.log(`${key}: ${value}`);
            }

            // Send API request with FormData
            axios.post('https://api.safree.org/api-v2022/organization/auth/v1/group-change-user-role', formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then((response) => {
                    console.log('API Response:', response.data);
                    if (response.data.success) {
                        // Update only the selected user's identity locally after successful API call
                        setOrganisations((prevOrganisations) =>
                            prevOrganisations.map((organisation) =>
                                organisation.userId === userId
                                    ? { ...organisation, identity: newIdentity }
                                    : organisation
                            )
                        );
                    } else {
                        setError('Failed to update identity');
                    }
                })
                .catch((error) => {
                    console.error('Error in changing role:', error);
                    setError('An error occurred while updating identity');
                });
        } else {
            console.log('Status change was canceled.');
        }
    };

    // DeleteFunction...?
    const handleDeleteUser = (userId) => {
        const confirmDelete = window.confirm("Are you sure you want to remove this user from the group?");

        if (confirmDelete) {
            console.log("Deleting user with userId:", userId);

            const token = localStorage.getItem("token");
            const formData = new FormData();
            formData.append("groupId", hashId); // Group ID from URL
            formData.append("userId", userId);  // User ID

            axios.post("https://api.safree.org/api-v2022/organization/auth/v1/remove-from-group", formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then((response) => {
                    console.log("Delete API Response:", response.data);
                    if (response.data.success) {
                        // Remove deleted user from state
                        setOrganisations((prevOrganisations) =>
                            prevOrganisations.filter((organisation) => organisation.userId !== userId)
                        );
                    } else {
                        setError("Failed to delete user from group");
                    }
                })
                .catch((error) => {
                    console.error("Error deleting user:", error);
                    setError("An error occurred while deleting the user");
                });
        } else {
            console.log("User deletion was canceled.");
        }
    };


    if (loading) return <div className="loading"><img src={Loader} alt="Loading" /></div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div className="container user-management">
            {/* Header Section */}
            <div className="row header">
                <div className="col-md-6">
                    {/* Display groupName */}
                    <p className="sub-heading">
                    <img onClick={handleBackClick} className="back-button" src={leftarrow} alt="" /> <strong>{groupName}</strong> Details
                    </p>
                </div>
                <div className="col-md-6 hedrcol2">
                    <Link to={`/admin2/orgGroupManagement/orgGroupViewDetail/addNewMember/#${hashId}`}>
                        Add New Member <img src={addbtn} alt="" />
                    </Link>
                </div>
            </div>
            <div className="content-wrapper">
                {/* Table Section */}
                <div className="table-container">
                    <table className="styled-table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone No</th>
                                <th>Identity</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentRows.map((organisation, index) => (
                                <tr key={organisation.userId || index}>
                                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                                    <td>{organisation.name}</td>
                                    <td>{organisation.email}</td>
                                    <td>{organisation.phoneNumber}</td>
                                    <td className='selecgurd'>
                                        <select
                                            value={organisation.identity}
                                            onChange={(e) => handleIdentityChange(organisation.userId, e.target.value)} // Use userId here
                                        >
                                            <option value="member">Member</option>
                                            <option value="guardian">Guardian</option>
                                        </select>
                                    </td>
                                    <td>
                                        <button className="btn btn-view" onClick={() => handleDeleteUser(organisation.userId)}>
                                            Remove
                                        </button>
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {/* Pagination Section */}
                    <div className="pagination-container">
                        <button
                            className="pagination-btn"
                            onClick={() => handlePageChange('prev')}
                            disabled={currentPage === 1}
                        >
                            &laquo; Prev
                        </button>
                        {Array.from({ length: totalPages }, (_, index) => (
                            <button
                                key={index}
                                className={`pagination-btn ${currentPage === index + 1 ? 'active' : ''}`}
                                onClick={() => setCurrentPage(index + 1)}
                            >
                                {index + 1}
                            </button>
                        ))}
                        <button
                            className="pagination-btn"
                            onClick={() => handlePageChange('next')}
                            disabled={currentPage === totalPages}
                        >
                            Next &raquo;
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrgGroupViewDetail;
